import { InMemoryCache } from '@apollo/client'
import { DemandFragment, TypedTypePolicies } from '../generated/graphql'
import possibleTypes from '../generated/graphql-possible-types'

const typePolicies: TypedTypePolicies = {
  Building: {
    fields: {
      demands: {
        merge(
          existing: DemandFragment[],
          incoming: DemandFragment[],
        ): DemandFragment[] {
          return incoming
        },
      },
    },
  },

  Provider: {
    fields: {
      hourSeries: {
        merge: false,
      },
      parameters: {
        keyArgs: false,
      },
      demands: {
        merge: false,
      },
    },
  },
}

export const cache = new InMemoryCache({
  typePolicies,
  possibleTypes: possibleTypes.possibleTypes,
})
